import { LanguageEnums } from "models/enums";
import { SelectInputItemProps } from "models/propTypes/wintFormPropsTypes";
import { TranslationKeys } from "translations";
import { EnumHelper, LocalizationHelperInstance } from "utils/helpers";

const LanguageHelper = {
  getLanguageCodeList: () => {
    return EnumHelper.getItemValues(LanguageEnums.LanguageCodes);
  },
  getLanguageAutoCompleteList: () => {
    return LanguageHelper.getLanguageCodeList().map((key, index) => ({
      id: key,
      value: LocalizationHelperInstance.getFormattedMessage(`Language.${(key as string).toUpperCase()}`),
      group: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Suggestions),
    }));
  },
  getLanguageSelectionList: (): SelectInputItemProps[] => {
    return LanguageHelper.getLanguageCodeList().map((key, index) => ({
      value: key as string,
      label: LocalizationHelperInstance.getFormattedMessage(`Language.${(key as string).toUpperCase()}`),
    }));
  },
  getLanguageText: (key: string) => {
    return LocalizationHelperInstance.getFormattedMessage(`Language.${key.toUpperCase()}`);
  },
};
export default LanguageHelper;
